import React from 'react';
import { connect } from 'react-redux';

import Page from '../../../page.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';
import { data as agreementDataPropTypes } from '../../../agreementPropTypes.js';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';
import withdrawalPropTypes from '../../../withdrawalPropTypes.js';
import formatOreToKroner from '../../../../lib/formatOreToKroner.js';
import ReceiptLink from '../../../receiptLink.jsx';
import FeedbackLink, { BUYER_SAD } from '../../../feedbackLink.jsx';

function getHeading({ partner, withdrawal }) {
    return withdrawal
        ? 'Kjøpet er hevet og du har fått tilbake pengene'
        : `${partner.name} har hevet kjøpet`;
}

const PaymentRevertedDetails = ({
    agreement,
    partner,
    payment,
    withdrawal,
}) => (
    <Page heading={getHeading({ partner, withdrawal })}>
        <div className="r-phl r-ptl">
            {withdrawal ? (
                <div>
                    <p>
                        Pengene er overført til din bankkonto. Du vil se pengene
                        på konto mellom 1&ndash;3 virkedager etter kjøpet ble
                        hevet.
                    </p>

                    <div className="r-phl">
                        <ReceiptLink payment={payment} />
                        <FeedbackLink type={BUYER_SAD} />
                    </div>
                </div>
            ) : (
                <div>
                    <p>
                        Du får tilbake hele summen på{' '}
                        {formatOreToKroner(agreement.total)}
                    </p>

                    <div className="r-phl">
                        <a
                            href={payment.withdrawFlowSpidUrl}
                            className="button r-mbl primary fullwidth"
                        >
                            Overfør pengene til din bankkonto
                        </a>
                        <ReceiptLink payment={payment} />
                        <FeedbackLink type={BUYER_SAD} />
                    </div>
                </div>
            )}
        </div>
    </Page>
);

PaymentRevertedDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
    withdrawal: withdrawalPropTypes,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement.data,
        partner: state.partner,
        payment: state.payment.data,
        withdrawal: state.withdrawal,
    };
}

export default connect(mapStateToProps)(PaymentRevertedDetails);



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/statusDetails/paymentRevertedDetails.jsx